module.exports = __webpack_public_path__ + "static/media/CoupleBeachWalk.c11923ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/registryOnboard/honeymoon/CoupleBeachWalk.png
// module id = 2026
// module chunks = 51